import React from 'react';
import { cx } from '../lib/hooks';
export function TitleMark({
  visible
}: {
  visible: boolean;
}) {
  return <div className={cx('pointer-events-none absolute left-5 top-5 z-20 flex items-center gap-2.5 transition-opacity duration-500 max-sm:left-3 max-sm:top-3', visible ? 'opacity-100' : 'opacity-0')} data-id="element-299" data-mp="3k78sh159nuo1">
      <div className="flex h-7 w-7 flex-col items-center justify-center gap-[3px] rounded-lg border border-white/[0.08] bg-white/[0.04]" data-id="element-300" data-mp="3afbejmmviolm">
        <span className="h-[2.5px] w-3.5 rounded-full bg-[#FBBF24]" data-id="element-301" data-mp="30iq8qz3159gq" />
        <span className="h-[2.5px] w-3.5 rounded-full bg-[#22D3EE]" data-id="element-302" data-mp="30gvkbasjuz7w" />
        <span className="h-[2.5px] w-3.5 rounded-full bg-[#A78BFA]" data-id="element-303" data-mp="2mkibeq230651" />
      </div>
      <span className="text-[13px] font-semibold tracking-[-0.01em] text-[#EDEEF2]" data-id="element-304" data-mp="2rjcuzu7vhyq7">How an LLM writes</span>
    </div>;
}